const roleNames = new Map<string, string>()
roleNames.set('employee', 'Empleado')
roleNames.set('admin', 'Administrador')
roleNames.set('supervisor', 'Supervisor')
roleNames.set('superadmin', 'SuperAdministrador')
roleNames.set(
  'admin users & supervisors',
  'Administrador de usuarios y supervisores'
)
roleNames.set('RRHH', 'Recursos Humanos')

export default roleNames
